import {notification} from 'antd';
import moment from 'moment';

interface Command {
    id: Id;
}

interface Meal {
    command: {
        id: Id;
    };
    status: string;
}

export default class DeliveryService {
    static getDeliveryStatus(status: string) {
        if (status.toLowerCase() == 'pending') {
            return 'En attente';
        } else if (status.toLowerCase() == 'in-progress') {
            return 'En cours';
        } else if (status.toLowerCase() == 'completed') {
            return 'Terminée';
        }
    }
    /**
     * Alerte quand des repas enregistrés n'ont pas pu être ajoutés à la tournée du client,
     * déjà en cours ou terminée pour leur jour de livraison (champ deliveryLocked de saveMeals).
     */
    static notifyLockedDeliveries(savedMeals?: { deliveryLocked?: boolean; day?: string; date?: string }[]) {
        const days = Array.from(new Set(
            (savedMeals || [])
                .filter((m) => m.deliveryLocked)
                .map((m) => moment(m.day || m.date).format('DD/MM/YYYY')),
        ));
        if (days.length === 0) {
            return;
        }
        notification.warning({
            message: 'Tournée déjà en cours',
            description: days.length > 1
                ? `Les tournées du ${days.join(', ')} sont déjà en cours : les repas enregistrés pour ces jours ne pourront pas y être ajoutés et ne seront pas livrés.`
                : `La tournée du ${days[0]} est déjà en cours : le repas enregistré pour ce jour ne pourra pas y être ajouté et ne sera pas livré.`,
            duration: 0,
        });
    }

    static getCommandsProgress(commands: Command[], meals: Meal[]) {
        let totalMeals = 0;
        let deliveredMeals = 0;
        commands.forEach((command) => {
            const clientMeals = meals.filter(
                (m) => m.command.id === command.id,
            );
            totalMeals += clientMeals.length;
            deliveredMeals += clientMeals.filter((m) =>
                ['delivered', 'failed'].includes(m.status),
            ).length;
        });

        return totalMeals > 0
            ? Math.round((deliveredMeals / totalMeals) * 100)
            : 0;
    }
}
